// removed by extract-text-webpack-plugin
module.exports = {"text800":"_3DLmD4Y3YUnAXyswrvI-Lg","text700":"_6RSadunHj64JGW6Jb76n9","text600":"Z5zMz4yyzxqkC39H24Cm","text500":"WXz1YOlhvbz5Ew1YrowBT","text400":"_1XWWsMIP_QENl7UtzY6zqh","text300":"_1fSmr2ir_-DoqnfwHOCgyb","text200":"_24FKf0JBh8dH9YZQNSOFNF","textParagraph":"uYBgVew-STv_Z_mcGYgA7","crimp":"_3wKTkmSPdb9sT-yTA1xbhK","trim":"_1iO1D5raKnUFs_IN7fGeze"};


//////////////////
// WEBPACK FOOTER
// ./src/imports/styles/styles.typography.scss
// module id = 352
// module chunks = 0